import { render, staticRenderFns } from "./auction-search-sort.vue?vue&type=template&id=6c823eea&"
import script from "./auction-search-sort.vue?vue&type=script&lang=js&"
export * from "./auction-search-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports